import type { ReactNode } from "react";

import { Icon } from "@core/components/Icon";
import type { SafeHtmlAttributes } from "@core/types/SafeHtmlAttributes";
import classnames from "classnames";

import type { DirectionalIconComponent } from "@jti/brand-icons";
import { UiCheckIcon } from "@jti/brand-icons/ui-check";
import { UiCheckCircleIcon } from "@jti/brand-icons/ui-check-circle";
import { UiInfoCircleBoldIcon } from "@jti/brand-icons/ui-info-circle-bold";
import { UiWarningIcon } from "@jti/brand-icons/ui-warning";

import styles from "./SupportingText.module.scss";

export type SupportingTextVariant = "info" | "error" | "success" | "checkmark";

export type SupportingTextProps = {
  variant?: SupportingTextVariant;
  children: ReactNode;
} & SafeHtmlAttributes<HTMLDivElement>;

const variantIconMap: Record<SupportingTextVariant, DirectionalIconComponent> = {
  info: UiInfoCircleBoldIcon,
  error: UiWarningIcon,
  success: UiCheckCircleIcon,
  checkmark: UiCheckIcon,
};

export const SupportingText = ({ variant = "info", children, ...rest }: SupportingTextProps) => (
  <div className={classnames(styles.root, styles[variant])} {...rest}>
    <Icon role="img" icon={variantIconMap[variant]} size="xs" aria-hidden="true" />
    <span className={styles.text}>{children}</span>
  </div>
);
